module.exports = __webpack_public_path__ + "media/images/joinus1-49bbb8c2fc3a4a20a2f8afa874ac6708.png";